import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import {
  BookingStore,
  InstallationsStore,
  noInstallationsError,
  VOUCHER_BOOKING_TABS,
} from '@store';
import { SubscriptionPlan } from '@vi-iot/client';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-booking-voucher',
  templateUrl: './booking-voucher.component.html',
  styleUrls: ['./booking-voucher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingVoucherComponent implements OnInit, OnDestroy {
  @ViewChild('stepper', { static: false }) stepper: MatStepper;

  readonly subscriptionPlan = SubscriptionPlan;

  currentStep = VOUCHER_BOOKING_TABS.SELECT_PLAN;
  selectedPlan: SubscriptionPlan;
  noInstallationsError = noInstallationsError;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public installationsStore: InstallationsStore,
    public bookingStore: BookingStore,
    private cdRef: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.bookingStore.resetUserSelection();
    this.bookingStore.loadBookingInstallation();
    this.bookingStore.loadInstallations();
    this.bookingStore.getAllVitoguideSubscriptions();
    this.bookingStore.getTrialSubscriptions();

    this.bookingStore.selectedPlan$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((plan) => {
      if (this.selectedPlan && !plan) {
        this.stepper.reset();
        this.cdRef.detectChanges();
      }
      this.selectedPlan = plan;
    });
    this.activatedRoute.queryParamMap.subscribe((paramMap) => {
      const step = paramMap.get('step');
      if (step === '3') {
        this.currentStep = VOUCHER_BOOKING_TABS.ACTIVATE_CODE;
        this.cdRef.detectChanges();
      }
    });
  }

  nextStep(stepper: MatStepper): void {
    stepper.selected.completed = true;
    stepper.next();
  }

  previousStep(stepper: MatStepper): void {
    stepper.selected.completed = false;
    stepper.previous();
  }

  initialStep(stepper: MatStepper): void {
    stepper.reset();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  navigateToCheckout(stepper: MatStepper): void {
    stepper.selectedIndex = 2;
  }

  initTrialStep(stepper: MatStepper): void {
    stepper.selectedIndex = 4;
  }

  resetSelectedPlan(): void {
    this.bookingStore.selectPlan(null);
  }

  goToInstallations(): void {
    this.router.navigate(['/installations']);
  }
}
